export default __webpack_public_path__ + "static/identity1a-d2e84c2e327458c082ec868b93fb7393.jpg";